<template>
  <div>
    <div v-if="status === 1">
      <v-icon color="success">{{ mdiCheckCircleOutline }}</v-icon>
      {{ $$t('enabled') }}
    </div>
    <div v-else-if="status === 2">
      <v-icon color="error">{{ mdiCloseCircle }}</v-icon>
      {{ $$t('enabled') }}
    </div>
    <div v-else>
      Status: {{ status }}
    </div>
  </div>
</template>

<script>
import { mdiCheckCircleOutline, mdiCloseCircle } from '@mdi/js';

export default {
  name: 'ListClientActiveIndicator',
  module: 'AdminClientLists',
  props: ['status'],
  data() {
    return {
      mdiCheckCircleOutline,
      mdiCloseCircle,
    };
  },
};
</script>
